import { useEffect, useState } from 'react';
import { useUserPreferences, useUpdatePreferences } from './useUserPreferences';

export type ChatPanelPosition = 'left' | 'right' | 'top' | 'bottom';

export interface ChatPanelLayout {
  position: ChatPanelPosition;
  setPosition: (p: ChatPanelPosition) => void;
  size: number;
  setSize: (n: number) => void;
  commitSize: () => void;
  isLoading: boolean;
}

const DEFAULT_POSITION: ChatPanelPosition = 'right';
const DEFAULT_SIZE = 360;

export function useChatPanelLayout(): ChatPanelLayout {
  const { data, isLoading } = useUserPreferences();
  const mutation = useUpdatePreferences();

  const position: ChatPanelPosition = data?.chat_file_panel_position ?? DEFAULT_POSITION;

  const [localSize, setLocalSize] = useState<number | null>(null);
  useEffect(() => {
    if (localSize === null && typeof data?.chat_file_panel_size === 'number') {
      setLocalSize(data.chat_file_panel_size);
    }
  }, [data, localSize]);
  const size = localSize ?? data?.chat_file_panel_size ?? DEFAULT_SIZE;

  return {
    position,
    setPosition: (p) => mutation.mutate({ chat_file_panel_position: p }),
    size,
    setSize: setLocalSize,
    commitSize: () => mutation.mutate({ chat_file_panel_size: size }),
    isLoading,
  };
}
